document.addEventListener("click", (e) => {
	const wrapper = e.target.closest("[data-tm]");
	if (!wrapper) return;

	const toggle = wrapper.querySelector(".tm-toggle");
	const panel = wrapper.querySelector(".tm-panel");

	if (toggle.contains(e.target)) {
		toggle.classList.toggle("is-active");
		panel.classList.toggle("tm-open");
	}
});
